// Vendor Components
import {graphql} from 'react-apollo';

// Vendor Types
import {ApolloQueryResult} from 'apollo-client';
import {OperationOption} from 'react-apollo/types';

// Mutations
import * as SignOutMutation from './sign-out.gql';

// Types
export interface SignOutResult {
  session: string;
}

export type SignOutFunc = () => Promise<ApolloQueryResult<SignOutResult>>;

export const options: OperationOption<{}, SignOutResult> = {
  props: ({mutate, ownProps}) => {
    const signOut: SignOutFunc = () => {
      return mutate!({});
    };

    return {
      ...ownProps,
      signOut
    };
  }
};

export default graphql<SignOutResult>(SignOutMutation, options);



// WEBPACK FOOTER //
// ./src/ui/authenticated/components/with-sign-out/with-sign-out.tsx